import {
    DocumentScanner,
    DocumentScannerOutlined,
    CloudUpload,
    FileOpen,
    Mic,
    MicOff,
    StopCircleOutlined,
    Brush,
    AddPhotoAlternate,
    HighlightAlt,
    AutoFixHigh,
    AddPhotoAlternateOutlined
} from "@mui/icons-material";
import React from "react";
import {Typography} from "@mui/material";
import {colorGray, colorIcon} from "../App/theme.js";
import CircularProgress from "@mui/material/CircularProgress";
import {defaultImageEditorInstructions} from "../Image/defaultInstructions";
import {MyServices, VisualModels} from "../constants";
import {isMobile} from "../App/utils";
import {VisionImageUpload} from "./VisionImageUpload";

const divStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '5px', marginBottom: '0px', marginRight: '-0px', marginLeft: '-10px'};
const fontSize = 8;
const labelStyle = { marginTop: 5};

const loadingMic = () => {
    return (
        <div style={{ position: 'relative', display: 'inline-block', marginTop: '4px' }}>
            <Mic style={{ color: colorGray }} />
            <CircularProgress
                size={24}
                style={{
                    color: colorGray,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: -14,
                    marginLeft: -12,
                }}
            />
        </div>
    )
}

function secondsToMMSS(isRecording) {
    const seconds = Math.round((isRecording[1] - isRecording[0])/1000 )
    let minutes = Math.floor(seconds / 60);
    let remainingSeconds = seconds % 60;
    let formattedMinutes = String(minutes).padStart(2, '0');
    let formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
}

function sortArrayLikeAnother(arr1, arr2) {
    arr1.sort((a, b) => {
        return arr2.indexOf(a) - arr2.indexOf(b);
    });
    return arr1;
}


export function sortInpaintPipes(pipes) {
    return sortArrayLikeAnother(pipes, [
        'stability.sdxlInpaint',
        'diffusers.sdxlInpaint',
        'runwayml.sdxlInpaint',
    ])
}

export function sortGenerationPipes(pipes) {
    return sortArrayLikeAnother(pipes, [
        'stability.sd35Large',
        'stability.sd3Medium',
        'stability.sdxl',
        'animagine.xl3',

    ])
}

export const pipeFrontendSettings = {
    "stabilityai--sdxl-turbo--default": {
        maxSteps: 4,
        realtime: true
    }
}

const createSpeechToText = (service, serviceId, name) =>  {
    const label = service?.serviceDescription;
    return {
        name,
        shortLabel: label,
        desc: 'speech to text',
        label,
        service,
        serviceId,
        type: 'speechToText',
        iconMobile: (props = {}) => {
            const {micEnabled, isRecording, isTalking, micLoading} = props;
            let icon = <Mic  />;
            let text = 'Speech';
            if (micLoading)  {
                icon = loadingMic();
            } else if (isTalking) {
                icon = <StopCircleOutlined className="pulsing2" style={{color: colorIcon}} />
            } else if (isRecording) {
                icon = <StopCircleOutlined style={{color: colorIcon}} />
            } else if (micEnabled === false) {
                icon = <MicOff />
            }

            const seconds = isRecording ? secondsToMMSS(isRecording) : '';
            const fontSizeRec = 18;
            return (
                <div key={props?.key} style={{...divStyle, display: 'flex', alignItems: 'center'}}>
                    <div style={{display: 'flex', alignItems: 'center', height: '24px'}}>
                        {icon}
                    </div>
                    {(isRecording) && <>
                        <p style={{fontSize: fontSizeRec, position: 'absolute', left: '250px', top: '0px'}}>{seconds}</p>
                        <p style={{fontSize: fontSizeRec, position: 'absolute', left: '40px', top: '0px'}}>Press 'Stop' to submit</p>
                    </>}
                    <Typography fontSize={fontSize} style={{...labelStyle}} >{text}</Typography>
                </div>
            )
        },
        icon: (props = {}) => {
            const {micEnabled, isRecording, isTalking, micLoading} = props;
            let icon;
            if (micLoading) icon = loadingMic();

            else if (isTalking) icon = <StopCircleOutlined className="pulsing2" style={{color: colorIcon}} />
            else if (isRecording) icon = <StopCircleOutlined style={{color: colorIcon}} />

            else if (micEnabled === false) icon =  <MicOff  />
            else icon = <Mic  style={props?.style} />;

            const seconds = isRecording ? secondsToMMSS(isRecording) : '';

            return <>
                {icon}
                {(isRecording) && <>
                    <p style={{position: 'absolute', left: '300px'}}>{seconds}</p><p style={{position: 'absolute', left: '50px'}}>Press 'Stop' to submit</p>
                </>}
            </>
            // Press 'Stop' to submit
        }
    }
};

export let inputTools = {
    visionImageUpload: {
        hidden: true,
        label: "Submit Image to AI",
        iconMobile: (props) => <div style={divStyle}>
            <AddPhotoAlternateOutlined key={props?.key} style={props?.style} />
            <Typography fontSize={fontSize} style={labelStyle}>Submit Image</Typography>
        </div>,
        icon: (props) => <AddPhotoAlternateOutlined key={props?.key} style={props?.style} />
    },
    uploadFile: {
        label: "Upload file",
        iconMobile: (props) => <div style={divStyle}>
            <CloudUpload key={props?.key} style={props?.style} />
            <Typography fontSize={fontSize} style={labelStyle}>Upload File</Typography>
        </div>,
        icon: (props) => <CloudUpload key={props?.key} style={props?.style} />
    },

    imageEditor: {
        label: "Add new Image Editor",
        desc: 'UI based on SDXL',
        iconMobile: (props) => <div style={divStyle}>
            <AddPhotoAlternate key={props?.key} style={props?.style} />
            <Typography fontSize={fontSize} style={labelStyle}>Image editor</Typography>
        </div>,
        icon: (props) => <AddPhotoAlternate key={props?.key} style={props?.style} />,
        iconSettings: (props) => <AutoFixHigh key={props?.key} style={props?.style} />
    },

    speechToText: createSpeechToText(MyServices["whisperLargeV3"], "whisperLargeV3", "speechToText"),

    imageToText: {
        label:  MyServices["gcp.textDetection"]?.serviceDescription,
        desc: 'image to text',
        service: MyServices["gcp.textDetection"],
        serviceId: "gcp.textDetection",
        iconMobile: (props) => <div style={divStyle}>
            <DocumentScannerOutlined key={props?.key} style={props?.style} />
            <Typography fontSize={fontSize} style={labelStyle}>Extract Text</Typography>
        </div>,
        icon: (props) => <DocumentScannerOutlined key={props?.key} style={props?.style} />
    },

    imageToTextAdvanced: {
        label: MyServices["gcp.textDetection"]?.serviceDescription,
        desc: isMobile ? 'image to text+data' : 'image to text + coordinates',
        service: MyServices["gcp.textDetection"],
        serviceId: "gcp.textDetection",
        icon: (props) => <DocumentScanner key={props?.key} style={props?.style} />,
        iconMobile: (props) => <div style={divStyle}>
            <DocumentScanner key={props?.key} style={props?.style} />
            <Typography fontSize={fontSize} style={labelStyle}>Extract Text</Typography>
        </div>,
    },

    docToText: {
        label: MyServices["documentToText"]?.serviceDescription,
        service: MyServices["documentToText"],
        serviceId: "documentToText",
        desc: 'document to text',
        icon: (props) => <FileOpen key={props?.key} style={props?.style} />,
        iconMobile: (props) => <div style={divStyle}>
            <FileOpen key={props?.key} style={props?.style} />
            <Typography fontSize={fontSize} style={labelStyle}>Extract Text</Typography>
        </div>,
    },
}